export * from "./src/blockquote-component";
